module.exports = __webpack_public_path__ + "img/walk-q19-1.bb039597.png";